/*
 * Copyright (c) 2020 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberDinghyBookingDialogController', MemberDinghyBookingDialogController);

    MemberDinghyBookingDialogController.$inject = ['$timeout', '$scope', '$state', '$uibModalInstance', 'ProfileService', '$http', '$sce', 'AlertService', 'entity', '$filter'];

    function MemberDinghyBookingDialogController ($timeout, $scope, $state, $uibModalInstance, ProfileService, $http, $sce, AlertService, entity, $filter) {
        var vm = this;

        $scope.status = {
            descriptionOpen: true,
            conditionsOpen: false
        };

        vm.dinghyEvent = entity;
        vm.booking = {};
        vm.booking.id = vm.dinghyEvent.id;
        // Activity Points
        vm.booking.pointCount = 0;
        vm.booking.individualQuestionAnswer = null;

        vm.clear = clear;
        vm.save = save;
        vm.pointsPicked = pointsPicked;

        var activityPointValue;
        ProfileService.getProfileInfo().then(function(response) {
            activityPointValue = response.activityPointValue;
            calcMaxPoints();
            vm.pointsPicked();
        });

        function calcMaxPoints () {
            var maxPointsToUse = Math.floor(vm.dinghyEvent.price / activityPointValue);
            $scope.maxPointCount = Math.min(vm.dinghyEvent.availableActivityPoints, maxPointsToUse);
        }

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        function pointsPicked () {
            $scope.price = vm.dinghyEvent.price - (vm.booking.pointCount * activityPointValue);
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            $http.post('api/member/dinghy-bookings/', vm.booking).then(function(response) {
                vm.error = null;
                AlertService.success('Du hast dich erfolgreich für das Event <b>' + vm.dinghyEvent.name + '</b> angemeldet.');
                $uibModalInstance.close(response);
                vm.isSaving = false;
            }, function() {
                vm.isSaving = false;
            });
        }

        $scope.renderHtml = function(code) {
            return $sce.trustAsHtml(code);
        };

        var trusted = {};
        $scope.getPopoverContent = function(content) {
            return trusted[content] || (trusted[content] = $sce.trustAsHtml(content));
        }
    }
})();
